// import React, { useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import "./CompleteRegistration.css";
// import publicApi from "../../apis/publicApi";
// import ButtonSpinner from "../../components/ButtonSpinner/ButtonSpinner";
// import Notification from "../../components/Notification/Notification";

// const CompleteRegistration = () => {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const token = new URLSearchParams(location.search).get("token");

//     const [password, setPassword] = useState("");
//     const [confirmPassword, setConfirmPassword] = useState("");
//     const [phoneNumber, setPhoneNumber] = useState("");
//     const [loading, setLoading] = useState(false);

//     const [notification, setNotification] = useState({
//         show: false,
//         message: "",
//         type: "info",
//     });

//     const handleCloseNotification = () => {
//         setNotification({ ...notification, show: false });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (password !== confirmPassword) {
//             setNotification({
//                 show: true,
//                 message: "Passwords do not match.",
//                 type: "error",
//             });
//             return;
//         }

//         setLoading(true);
//         setNotification({ show: false, message: "", type: "info" });

//         try {
//             console.log(password, phoneNumber)
//             const res = await publicApi.post(`/api/auth/complete-registration?token=${token}`, { password, phoneNumber });

//             if (res?.data?.success) {
//                 setNotification({
//                     show: true,
//                     message: res.data.message || "Registration completed successfully!",
//                     type: "success",
//                 });

//                 setTimeout(() => {
//                     navigate("/login", { state: { message: "You can now log in." } });
//                 }, 1500);
//             } else {
//                 setNotification({
//                     show: true,
//                     message: res?.data?.message || "Failed to complete registration.",
//                     type: "error",
//                 });
//             }
//         } catch (err) {
//             console.error(err);
//             setNotification({
//                 show: true,
//                 message: err?.response?.data?.message || "Something went wrong.",
//                 type: "error",
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="complete-registration-container">
//             <div className="complete-registration-card">
//                 <h2>Complete Registration</h2>

//                 <Notification
//                     show={notification.show}
//                     message={notification.message}
//                     type={notification.type}
//                     onClose={handleCloseNotification}
//                 />

//                 <form onSubmit={handleSubmit}>
//                     <label htmlFor="password">Password</label>
//                     <input
//                         id="password"
//                         type="password"
//                         placeholder="Enter your password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         required
//                     />

//                     <label htmlFor="confirmPassword">Confirm Password</label>
//                     <input
//                         id="confirmPassword"
//                         type="password"
//                         placeholder="Confirm your password"
//                         value={confirmPassword}
//                         onChange={(e) => setConfirmPassword(e.target.value)}
//                         required
//                     />

//                     <label htmlFor="phoneNumber">Phone Number (optional)</label>
//                     <input
//                         id="phoneNumber"
//                         type="text"
//                         placeholder="Enter your phone number"
//                         value={phoneNumber}
//                         onChange={(e) => setPhoneNumber(e.target.value)}
//                     />

//                     <button type="submit" disabled={loading}>
//                         {loading ? (
//                             <ButtonSpinner
//                                 size={10}
//                                 textColor={"#fff"}
//                                 backgroundColor="#fff"
//                                 loadingInfo="Completing..."
//                                 color="transparent"
//                             />
//                         ) : (
//                             "Complete Registration"
//                         )}
//                     </button>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default CompleteRegistration;

import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./CompleteRegistration.css";
import publicApi from "../../apis/publicApi";
import ButtonSpinner from "../../components/ButtonSpinner/ButtonSpinner";
import Notification from "../../components/Notification/Notification";

const CompleteRegistration = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const token = new URLSearchParams(location.search).get("token");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [loading, setLoading] = useState(false);

    const [notification, setNotification] = useState({
        show: false, message: "", type: "info",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setNotification({ show: true, message: "Passwords do not match.", type: "error" });
            return;
        }

        setLoading(true);
        setNotification({ show: false, message: "", type: "info" });

        try {
            const res = await publicApi.post(
                `/api/auth/complete-registration?token=${token}`,
                { password, phoneNumber }
            );

            if (res?.data?.success) {
                setNotification({
                    show: true,
                    message: res.data.message || "Registration completed successfully!",
                    type: "success",
                });
                setTimeout(() => navigate("/login", { state: { message: "You can now log in." } }), 1500);
            } else {
                setNotification({
                    show: true,
                    message: res?.data?.message || "Failed to complete registration.",
                    type: "error",
                });
            }
        } catch (err) {
            setNotification({
                show: true,
                message: err?.response?.data?.message || "Something went wrong.",
                type: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="cr-page">
            <div className="cr-card">
                {/* Header */}
                <div className="cr-card-header">
                    <div className="cr-logo">
                        <span className="cr-logo-text">🇳🇬</span>
                    </div>
                    <h2>Complete Registration</h2>
                    <p>Set your password to activate your government portal account</p>
                </div>

                <Notification
                    show={notification.show}
                    message={notification.message}
                    type={notification.type}
                    onClose={() => setNotification(p => ({ ...p, show: false }))}
                />

                <form className="cr-form-body" onSubmit={handleSubmit}>
                    <div className="cr-field">
                        <label className="cr-label required" htmlFor="password">Password</label>
                        <input
                            id="password"
                            className="cr-input"
                            type="password"
                            placeholder="Create a strong password…"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                            autoComplete="new-password"
                        />
                        <span className="cr-hint">Minimum 8 characters recommended</span>
                    </div>

                    <div className="cr-field">
                        <label className="cr-label required" htmlFor="confirmPassword">Confirm Password</label>
                        <input
                            id="confirmPassword"
                            className="cr-input"
                            type="password"
                            placeholder="Re-enter your password…"
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            required
                            autoComplete="new-password"
                        />
                    </div>

                    <div className="cr-field">
                        <label className="cr-label optional" htmlFor="phoneNumber">Phone Number</label>
                        <input
                            id="phoneNumber"
                            className="cr-input"
                            type="tel"
                            placeholder="e.g. +234 801 234 5678"
                            value={phoneNumber}
                            onChange={e => setPhoneNumber(e.target.value)}
                            autoComplete="tel"
                        />
                    </div>

                    <button type="submit" className="cr-submit-btn" disabled={loading}>
                        {loading ? (
                            <ButtonSpinner
                                size={10}
                                textColor="#fff"
                                backgroundColor="#fff"
                                loadingInfo="Completing…"
                                color="transparent"
                            />
                        ) : (
                            "✓ Complete Registration"
                        )}
                    </button>

                    <p className="cr-footer">
                        Already have an account? <a href="/login">Sign in</a>
                    </p>
                </form>
            </div>
        </div>
    );
};

export default CompleteRegistration;